import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import Modal from '../titled-modal/titled-modal.jsx';

import styles from './login-modal.css';

const LoginModalComponent = props => (
    <Modal
        className={classNames(styles.modalContent, props.className)}
        contentLabel={props.contentLabel}
        isOpen={props.isOpen}
        overlayClassName={styles.modalOverlay}
        onRequestClose={props.onRequestClose}
    >
        {props.children}
    </Modal>
);

LoginModalComponent.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    contentLabel: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]).isRequired,
    isOpen: PropTypes.bool,
    onRequestClose: PropTypes.func
};

export default LoginModalComponent;
